export const CELL_DATA_UPDATED = 'CELL_DATA_UPDATED';
export const CELL_SELECTED = 'CELL_SELECTED';
export const CELL_UNSELECTED = 'CELL_UNSELECTED';

export default {
    updated: CELL_DATA_UPDATED,
    selected: CELL_SELECTED,
    unselected: CELL_UNSELECTED
};
